import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { connect } from 'react-redux';
import styles from '../../styles.module.css';

const { Option, OptGroup } = Select;

class CategoryCell extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: false,
    };
  }

  toggleEdit = () => {
    const { editing } = this.state;
    this.setState({ editing: !editing }, () => {
      const { editing: isEdit } = this.state;
      if (isEdit) {
        this.input.focus();
      }
    });
  };

  onCategorySelected = (category, option) => {
    this.toggleEdit();
    const { onCategorySelected } = this.props;
    onCategorySelected({ categoryId: category, categoryName: option.props.children });
  };

  render() {
    const { value, categories: allCategories, direction } = this.props;
    const { editing } = this.state;
    const typeName = (value && value.name) || null;
    const typeId = (value && value.id) || null;

    const categories = allCategories.filter((group) => group.transaction_direction === direction);

    let text;
    if (typeName) {
      text = <span className={styles.Value}>{typeName}</span>;
    } else {
      text = <span className={styles.NoSelected}>Not specified</span>;
    }

    if (editing) {
      return (
        <Select
          placeholder="Not specified"
          showArrow={false}
          ref={(node) => {
            this.input = node;
          }}
          defaultValue={typeId || undefined}
          dropdownMatchSelectWidth={false}
          defaultOpen
          onChange={this.onCategorySelected}
          onBlur={this.toggleEdit}
        >
          {categories && categories.map((group) => (
            <OptGroup
              key={group.id}
              label={group.group_name}
            >
              {group.categories.map((category) => (
                <Option
                  key={category.id}
                  value={category.id}
                >
                  {category.name}
                </Option>
              ))}
            </OptGroup>
          ))}
        </Select>
      );
    }

    return <div onClick={this.toggleEdit}>{text}</div>;
  }
}

CategoryCell.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  direction: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({
    transaction_direction: PropTypes.string,
  })),
  onCategorySelected: PropTypes.func.isRequired,
};

CategoryCell.defaultProps = {
  value: undefined,
  categories: null,
};

const mapStateToProps = ({ categoriesService }) => ({
  categories: categoriesService.categories,
});

export default connect(mapStateToProps)(CategoryCell);
